import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';


const firebaseConfig = {
  // apiKey: "AIzaSyCf_Nk2zXlVyOwKaDkmu6NHxPcMnuUf6kM",
  // authDomain: "ingressos-hoomweb.firebaseapp.com",
  // databaseURL: "https://ingressos-hoomweb.firebaseio.com",
  // projectId: "ingressos-hoomweb",
  // storageBucket: "",
  // messagingSenderId: "89913644566",
  // appId: "1:89913644566:web:0508eb90d087aaa1"

  apiKey: "AIzaSyAn2Vgu3mCtFTct4r70rG7LJX9NmRH3ORI",
  authDomain: "profkennycourse.firebaseapp.com",
  databaseURL: "https://profkennycourse.firebaseio.com",
  projectId: "profkennycourse",
  storageBucket: "profkennycourse.appspot.com",
  messagingSenderId: "925746720341",
  appId: "1:925746720341:web:f28d902a6060597b"
};

firebase.initializeApp(firebaseConfig);

const firestore = firebase.firestore();
firestore.enablePersistence();

export default {
  firestore,
  auth: firebase.auth(),

};

const initializeAuth = new Promise(resolve => {
  // this adds a hook for the initial auth-change event
  firebase.auth().onAuthStateChanged(user => {
    authService.setUser(user);
    resolve(user);
  });
});

export const authService = {

  user: null,

  async authenticated() {
    //console.log('authenticated');
    const user = await initializeAuth;

    if (user != null) {
      user.getIdToken().then(function (data) {
        //console.log(data);
      });
    }
    return user && !user.isAnonymous;
  },

  async validToken() {
    //console.log('authenticated');
    const user = await initializeAuth;


    return await user.getIdToken();


  },

  setUser(user) {
    this.user = user;
  },

  login(email, password) {
    return firebase.auth().signInWithEmailAndPassword(email, password);
  },

  logout() {
    firebase.auth().signOut().then(() => {
      console.log('logout done');
    });
  }
};

export const socialLogin = {
  facebook() {
    const provider = new firebase.auth.FacebookAuthProvider();
    provider.addScope("email");
    provider.addScope("public_profile");
    provider.setCustomParameters({
      display: "popup"
    });

    return firebase.auth().signInWithPopup(provider);
  },
  google() {
    const provider = new firebase.auth.GoogleAuthProvider();
    provider.setCustomParameters({
      display: "popup"
    });

    return firebase.auth().signInWithPopup(provider);
  }
}
